import React from 'react'
import cx from 'classnames'
import { Link } from '@reach/router'
import arrowRight from '../graphics/arrow-right-moon-gray.svg'

export const Breadcrumb = ({ links, className }) => (
  <nav className={cx('mt2 mb3 flex items-center f7', className)}>
    {links.map(({ url, title }, i) => (
      <span key={title}>
        {i > 0 && (
          <img src={arrowRight} alt="" width="7" height="6" className="mr1" />
        )}
        {url ? (
          <Link to={url} className="link orange underline-hover pr1">
            {title}
          </Link>
        ) : (
          <span className="moon-gray pr1">{title}</span>
        )}
      </span>
    ))}
  </nav>
)

export default Breadcrumb
